module.exports = __webpack_public_path__ + "img/logo-tech.a543b655.png";